export default "__VITE_ASSET__BgNjZ$B___"